import { combineReducers } from 'redux';
import { createReducer } from 'typesafe-actions';

import {
  fetchHotelListAsync,
  fetchHotelListFilterAsync,
  fetchMoreHotelListAsync,
  setIsFirstTimeLoading,
  updatePendingFilters,
} from './actions';

import type { HotelList, HotelListErrors } from 'HotelList-Types';

export const isFetchingList = createReducer(false)
  .handleAction([fetchHotelListAsync.request], () => true)
  .handleAction([fetchHotelListAsync.success, fetchHotelListAsync.failure], () => false);

export const isFetchingMoreHotels = createReducer(false)
  .handleAction([fetchMoreHotelListAsync.request], () => true)
  .handleAction([fetchMoreHotelListAsync.success, fetchMoreHotelListAsync.failure], () => false);

export const hotels = createReducer({} as HotelList)
  .handleAction(fetchHotelListAsync.success, (_state, action) => action.payload)
  .handleAction(fetchHotelListAsync.failure, () => ({}) as HotelList)
  .handleAction(fetchMoreHotelListAsync.success, (state, action) => ({
    ...state,
    offset: action.payload.offset,
    limit: action.payload.limit,
    providers: state.providers.concat(action.payload.providers),
  }));

export const errors = createReducer([] as HotelListErrors[])
  .handleAction(
    [fetchHotelListAsync.failure, fetchMoreHotelListAsync.failure],
    (_state, action) => action.payload,
  )
  .handleAction(
    [fetchHotelListAsync.request, fetchMoreHotelListAsync.request],
    () => [] as HotelListErrors[],
  );

// only being used as pending filters while filter selection
export const isFetchingFilters = createReducer(false)
  .handleAction(fetchHotelListFilterAsync.request, () => true)
  .handleAction(
    [fetchHotelListFilterAsync.success, fetchHotelListFilterAsync.failure],
    () => false,
  );

export const prefetchedHotels = createReducer({} as HotelList)
  .handleAction(
    [updatePendingFilters, fetchHotelListAsync.success, fetchHotelListFilterAsync.success],
    (_state, action) => action.payload,
  )
  .handleAction(fetchHotelListAsync.failure, () => ({}) as HotelList);

export const isFirstTimeLoading = createReducer(true as boolean).handleAction(
  setIsFirstTimeLoading,
  (_status, action) => action.payload,
);

const HotelListReducer = combineReducers({
  hotels,
  prefetchedHotels,
  errors,
  isFetchingList,
  isFetchingMoreHotels,
  isFetchingFilters,
  isFirstTimeLoading,
});

export default HotelListReducer;
export type HotelListState = ReturnType<typeof HotelListReducer>;
